export default [
  {
    path: "/manage",
    name: "",
    component: (resolve) => require(["@/views/home"], resolve),
    children: [
      {
        path: "contributor",
        name: "期刊简介",
        meta: {
          title: "期刊简介",
        },
        component: (resolve) => require(["@/views/manage/author"], resolve),
      },
      {
        //在线投稿
        path: "author",
        name: "在线投稿",
        meta: {
          title: "在线投稿",
        },
        component: (resolve) =>
          require(["@/views/manage/contributor/index"], resolve),
      },
      {
        //投稿须知
        path: "notice",
        name: "投稿须知",
        meta: {
          title: "投稿须知",
        },
        component: (resolve) =>
          require(["@/views/manage/notice/index"], resolve),
      },
      {
        //投稿页面
        path: "publish",
        name: "投稿",
        meta: {
          title: "投稿",
        },
        component: (resolve) =>
          require(["@/views/manage/contributor/publish"], resolve),
      },
      {
        //
        path: "check",
        name: "在线查看",
        meta: {
          title: "在线查看",
        },
        component: (resolve) =>
          require(["@/views/manage/check/index"], resolve),
      },
      {
        //
        path: "ricsview",
        name: "在线编辑",
        meta: {
          title: "在线编辑",
        },
        component: (resolve) =>
          require(["@/views/manage/ricsview/index"], resolve),
      },
      {
        //
        path: "times",
        name: "在线编辑",
        meta: {
          title: "在线编辑",
        },
        component: (resolve) =>
          require(["@/views/manage/ricsview/times"], resolve),
      },
      {
        //版权协议
        path: "copyright",
        name: "版权协议",
        meta: {
          title: "版权协议",
        },
        component: (resolve) =>
          require(["@/views/manage/notice/copyright"], resolve),
      },
      {
        //版权协议
        path: "editing",
        name: "选择采编",
        meta: {
          title: "选择采编",
        },
        component: (resolve) =>
          require(["@/views/manage/notice/editing"], resolve),
      },
      {
        path: "contributorInformation",
        name: "在线投稿",
        meta: {
          title: "在线投稿",
        },
        component: (resolve) =>
          require(["@/views/manage/contributorInformation/index"], resolve),
      },

      {
        path: "submissionInformation",
        name: "在线投稿信息",
        meta: {
          title: "在线投稿信息",
        },
        component: (resolve) =>
          require([
            "@/views/manage/contributorInformation/submissionInformation",
          ], resolve),
      },
      {
        path: "submission",
        name: "投稿确认",
        meta: {
          title: "投稿确认",
        },
        component: (resolve) =>
          require(["@/views/manage/contributor/submission"], resolve),
      },
      {
        path: "manuFinish",
        name: "投稿确认",
        meta: {
          title: "投稿确认",
        },
        component: (resolve) =>
          require(["@/views/manage/contributor/manuFinish"], resolve),
      },
      {
        path: "edit",
        name: "修改稿件",
        meta: {
          title: "修改稿件",
        },
        component: (resolve) => require(["@/components/editor"], resolve),
      },
      {
        path: "mySubmission",
        name: "我的投稿",
        meta: {
          title: "我的投稿",
        },
        component: (resolve) =>
          require(["@/views/manage/mySubmission/index"], resolve),
      },
      {
        path: "articleDetail",
        name: "稿件详情",
        meta: {
          title: "稿件详情",
        },
        component: (resolve) =>
          require(["@/views/manage/mySubmission/articleDetail"], resolve),
      },
      // 2023/11 校样确认
      {
        path: "confirmArticleProof",
        name: "校样确认",
        meta: {
          title: "校样确认",
        },
        component: (resolve) =>
          require(["@/views/manage/mySubmission/confirmArticleProof"], resolve),
      },
      {
        path: "confirmationPayment",
        name: "付款确认",
        meta: {
          title: "付款确认",
        },
        component: (resolve) =>
          require(["@/views/manage/mySubmission/confirmationPayment"], resolve),
      },
      {
        path: "payment",
        name: "订单支付",
        meta: {
          title: "订单支付",
        },
        component: (resolve) =>
          require(["@/views/manage/mySubmission/payment"], resolve),
      },
      {
        path: "orderManagement",
        name: "订单管理",
        meta: {
          title: "订单管理",
        },
        component: (resolve) =>
          require(["@/views/manage/orderManagement/index"], resolve),
      },
      {
        path: "orderDetail",
        name: "订单详情",
        meta: {
          title: "订单详情",
        },
        component: (resolve) =>
          require(["@/views/manage/orderManagement/orderDetail"], resolve),
      },
      // v3.0.4 支付后拦截
      {
        path: "annexInterception",
        name: "附件补充",
        meta: {
          title: "附件补充",
        },
        component: (resolve) =>
          require(["@/views/manage/orderManagement/annexInterception"], resolve),
      },
      {
        path: "invoiceEnquiry",
        name: "发票查询",
        meta: {
          title: "发票查询",
        },
        component: (resolve) =>
          require(["@/views/manage/invoiceEnquiry/index"], resolve),
      },
      {
        path: "scrapBin",
        name: "废件箱",
        meta: {
          title: "废件箱",
        },
        component: (resolve) =>
          require(["@/views/manage/scrapBin/index"], resolve),
      },
      {
        path: "otherSettings",
        name: "其他设置",
        meta: {
          title: "其他设置",
        },
        component: (resolve) =>
          require(["@/views/manage/otherSettings/index"], resolve),
      },
      {
        path: "messageNotification",
        name: "我的消息",
        meta: {
          title: "我的消息",
        },
        component: (resolve) =>
          require(["@/views/manage/messageNotification/index"], resolve),
      },
      // 2022/08/08 新增router
      {
        path: "nameCard",
        name: "名片夹",
        meta: {
          title: "名片夹",
        },
        component: (resolve) =>
          require(["@/views/manage/nameCard/index"], resolve),
      },
      {
        path: "seeRecords",
        name: "浏览记录",
        meta: {
          title: "浏览记录",
        },
        component: (resolve) =>
          require(["@/views/manage/seeRecords/index"], resolve),
      },
      {
        path: "inquiryService",
        name: "咨询与投诉",
        meta: {
          title: "咨询与投诉",
        },
        component: (resolve) =>
          require(["@/views/manage/inquiryService/index"], resolve),
      },
      {
        path: "editorialCenter",
        name: "采编中心",
        meta: {
          title: "采编中心",
        },
        component: (resolve) =>
          require(["@/views/manage/editorialCenter/index"], resolve),
      },
    ],
  }, //第二大类共用部分
  {
    path: "/loginAdmin",
    name: "用户反馈",
    meta: {
      title: "用户反馈",
    },
    component: (resolve) => require(["@/views/manage/loginAdmin/index"], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/router/manage_routers.js